
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ViaAccess, ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class ViaAccessEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    viaAccess: ViaAccess;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getViaAccess()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getViaAccess(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.viaAccess = data;
                this.onDataChanged.next(this.viaAccess);
                resolve(this.viaAccess);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('viaAccess/' + this.routeParams.id).subscribe((res: ViaAccess ) => {
                    this.viaAccess = res;
                    this.onDataChanged.next(this.viaAccess);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(viaAccess): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('viaAccess/', viaAccess).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(viaAccess): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('viaAccess/', viaAccess).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(viaAccess): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('viaAccess/' + viaAccess.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    checkLastModifications(): ViaAccess {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
